import { HTTP } from '@/api/http-common'
import { HttpFunctions } from '@/api/http-functions'

export default {
  getDefaultSortingOptions (params, callback) {
    HTTP.get('default/sort/option?language=' + params).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  saveProductDefaultSortOptionSetting (param, callback) {
    HTTP.put('default/sort/option/products', param).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  saveCategoryDefaultSortOptionSetting (param, callback) {
    HTTP.put('default/sort/option/category', param).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/sort_options/index.js